import {
  InputSearchAdvancedSuggestion,
  InputSearchAdvancedSuggestionGroup,
  type SuggestionGroupAllowedChildren,
} from '@//components/InputSearchAdvanced';
import type { Section, SectionType } from '@//hooks/useSuggestionFoldoutManager';

interface SuggestionDropdownProps<G, V, A, H> {
  id: string;
  sections: Readonly<[Section<G>, Section<V>, Section<A>, Section<H>]>;
  activeIndex: number;
  activeSection: SectionType | null;
  renderGeoLocation?: (item: G, isActive: boolean) => SuggestionGroupAllowedChildren;
  renderVehicle?: (item: V, isActive: boolean) => SuggestionGroupAllowedChildren;
  renderArticle?: (item: A, isActive: boolean) => SuggestionGroupAllowedChildren;
  renderHistory?: (item: H, isActive: boolean) => SuggestionGroupAllowedChildren;
}

export const SuggestionDropdown = <G, V, A, H>({
  id,
  sections,
  activeIndex,
  activeSection,
  renderGeoLocation,
  renderVehicle,
  renderArticle,
  renderHistory,
}: SuggestionDropdownProps<G, V, A, H>) => {
  let absIdx = 0;

  return (
    <InputSearchAdvancedSuggestion id={`${id}-suggestions-list`}>
      {sections.map(
        (section) =>
          section.items.length > 0 && (
            <InputSearchAdvancedSuggestionGroup
              key={section.type}
              id={`${id}-${section.type}-group`}
              label={section.label}
            >
              {section.items.map((item) => {
                const isActive = activeIndex === absIdx && activeSection === section.type;
                absIdx++;
                if (section.type === 'geoLocation' && renderGeoLocation) {
                  return renderGeoLocation(item as G, isActive);
                }
                if (section.type === 'vehicle' && renderVehicle) {
                  return renderVehicle(item as V, isActive);
                }
                if (section.type === 'article' && renderArticle) {
                  return renderArticle(item as A, isActive);
                }
                if (section.type === 'history' && renderHistory) {
                  return renderHistory(item as H, isActive);
                }
                return null;
              })}
            </InputSearchAdvancedSuggestionGroup>
          ),
      )}
    </InputSearchAdvancedSuggestion>
  );
};
